export enum UserRoles {
  ADMIN = 'admin',
  EDITOR = 'editor',
  PDF_ONLY = 'pdf_only',
}
